/* Limites do backend (Formulario\QuestionBankController::MIN_OPCOES e
   MAX_OPCOES). Diferente do quiz, que exige exatamente quatro, e sem
   alternativa correta: o formulário coleta opinião, não avalia. */
export const MIN_OPCOES = 2;
export const MAX_OPCOES = 10;

export const letraDaOpcao = index => String.fromCharCode(65 + index);

/* Tempo por pergunta, em segundos. 0 é "sem limite": a coluna
   form_forms.tempo_por_pergunta não aceita nulo, e 0 nunca foi um limite
   válido (o mínimo é 5). Mesmo sem limite, o player mede quanto o aluno levou
   em cada pergunta e manda em `tempo_resposta`. */
export const TEMPO_ILIMITADO = 0;
export const TEMPO_PADRAO = 20;
export const TEMPO_MINIMO = 5;
export const TEMPO_MAXIMO = 600;

export const isTempoIlimitado = segundos =>
  segundos !== null &&
  segundos !== undefined &&
  Number(segundos) === TEMPO_ILIMITADO;

/** Tempo salvo no formulário, sem transformar o 0 (ilimitado) no padrão. */
export const tempoDoFormulario = segundos =>
  segundos === null || segundos === undefined || segundos === ""
    ? TEMPO_PADRAO
    : Number(segundos);

/** Relógio do player e dos relatórios: 75 → "1:15". */
export const formatarRelogio = segundos => {
  const total = Math.max(0, Math.floor(Number(segundos) || 0));
  const minutos = Math.floor(total / 60);
  return `${minutos}:${String(total % 60).padStart(2, "0")}`;
};
